import * as React from "react";
import styles from "./block.module.scss";

type Props = {
  icon: React.ReactNode;
  name: string;
  description: string;
  id: number;
  selectedBlock: number;
  setSelectedBlock: React.Dispatch<React.SetStateAction<number>>;
};

const VendorsBlock: React.FC<Props> = (props) => {
  return (
    <div
      className={`${
        props.selectedBlock == props.id ? styles["block__active"] : ""
      } ${styles["block"]}`}
      onClick={() => props.setSelectedBlock(props.id)}
    >
      <div>{props.icon}</div>
      <div className={styles["block__column"]}>
        <h4 className={styles["block__heading"]}>{props.name}</h4>
        {props.selectedBlock === props.id && (
          <p className={styles["block__body"]}>{props.description}</p>
        )}
      </div>
    </div>
  );
};

export default VendorsBlock;
